import {
  Directive,
  ElementRef,
  HostListener,
  ViewContainerRef,
  ComponentRef,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { CalenderComponent } from "../components/calender/calender.component";
import { Subscription } from "rxjs";

@Directive({
  selector: "[appCalender]",
  standalone: true,
})
export class CalenderDirective implements OnDestroy {
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() futureDate: boolean = true;

  @Output() dateRangeChanged = new EventEmitter<{
    startDate: Date;
    endDate: Date | null;
  }>();

  private componentRef: ComponentRef<CalenderComponent> | null = null;
  private subscriptions: Subscription[] = [];

  constructor(
    private readonly elementRef: ElementRef,
    private readonly viewContainerRef: ViewContainerRef,
  ) {}

  @HostListener("click", ["$event"])
  onClick(event: MouseEvent) {
    event.stopPropagation();
    if (this.componentRef) {
      this.closeCalendar();
    } else {
      this.openCalendar();
    }
  }

  private openCalendar() {
    this.viewContainerRef.clear();
    this.componentRef =
      this.viewContainerRef.createComponent(CalenderComponent);

    // Set inputs
    this.componentRef.instance.initialStartDate = this.startDate;
    this.componentRef.instance.initialEndDate = this.endDate;
    this.componentRef.instance.disableFutureDates = this.futureDate;

    // Position the calendar as requested by the user
    // style="position: fixed;top: 10px;left: 625px;"
    const style = this.componentRef.location.nativeElement.style;
    style.position = "fixed";
    style.top = "10px";
    style.left = "340px";

    // Subscribe to events
    const rangeSelectedSub = this.componentRef.instance.rangeSelected.subscribe(
      (range) => {
        this.dateRangeChanged.emit(range);
        this.closeCalendar();
      },
    );

    this.subscriptions.push(rangeSelectedSub);

    const closeSub = this.componentRef.instance.closeCalender.subscribe(() => {
      this.closeCalendar();
    });

    this.subscriptions.push(closeSub);

    // Handle outside clicks
    setTimeout(() => {
      globalThis.addEventListener("click", this.outsideClickHandler, true);
    }, 0);
  }

  private readonly outsideClickHandler = (event: MouseEvent) => {
    if (!this.componentRef) {
      return;
    }

    const eventTarget = event.target;
    if (!(eventTarget instanceof Node)) {
      event.stopPropagation();
      this.closeCalendar();
      return;
    }

    const calendarNativeElement = this.componentRef.location.nativeElement;
    const isInsideCalendar =
      typeof calendarNativeElement?.contains === "function"
        ? calendarNativeElement.contains(eventTarget)
        : calendarNativeElement === eventTarget;

    if (!isInsideCalendar) {
      // Stop bubbling so parent overlays (e.g. filter dialog backdrop) don't close.
      event.stopPropagation();
      this.closeCalendar();
    }
  };

  private closeCalendar() {
    if (this.componentRef) {
      this.viewContainerRef.clear();
      this.componentRef = null;

      // Unsubscribe from all subscriptions
      this.subscriptions.forEach((sub) => sub.unsubscribe());
      this.subscriptions = [];

      globalThis.removeEventListener("click", this.outsideClickHandler, true);
    }
  }

  ngOnDestroy(): void {
    this.closeCalendar();
    globalThis.removeEventListener("click", this.outsideClickHandler, true);
  }
}
